import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'lib-bw-svc-apis/src/lib/auth/auth.guard';
import { NoLoginGuard } from 'lib-bw-svc-apis/src/lib/NoLoginGuard/no-login.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [NoLoginGuard],
    canLoad: [NoLoginGuard],
    loadChildren: () => import('app-bw-ext/src/app/Authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'about-ai',
    loadChildren: () => import('app-bw-ext/src/app/about-ai/about-ai.module').then(m => m.AboutAiModule)
  },
  {
    path: 'browser-access-restriction',
    loadChildren: () => import('app-bw-ext/src/app/restricted-browser-access/restricted-browser-access.module').then(m => m.RestrictedBrowserAccessModule)
  },
  {
    path: 'Auth/SSO/SP/Login',
    loadChildren: () => import('app-bw-ext/src/app/Authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'ExtUserView',
    loadChildren: () => import('app-bw-ext/src/app/external-user/ext-user-home/ext-user-home.module').then(m => m.ExtUserHomeModule)
  },
  {
    path: 'admin',
    data: {
      role: '',
      title: 'BoardWorks Admin'
    },
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () => import('app-bw-admin/src/app/app.module').then(m => m.AppModule)
  },
  {
    path: 'Meetings',
    data: {
      role: '',
      title: 'Admin'
    },
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () => import('app-bw-admin/src/app/app.module').then(m => m.AppModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
